import React from 'react'
import UFCComp from '../../components/sponsorships/UFC'

const UFC = () => {
  return (
    <UFCComp/>
  )
}

export default UFC